import { ListItem } from "@material-ui/core";
import React from "react";
import DetailSection from "../../components/DetailSection";
import { AlignedListContainer } from "../../components/layouts";
import EnhancedStatusDisplay from "../../components/EnhancedStatusDisplay";
import Time from "../../lithic/Moment";
import { renderItem } from "./ReportingAccountEnrollmentDetailPage";
import { ReportingAccountEnrollmentVerifications } from "./ReportingAccountEnrollmentVerifications";

export const EnrollmentDetails = ({ enrollment }) => {
  const submitted = enrollment.auditLogs?.find((al) => al.event === "submit")?.at;

  return (
    <AlignedListContainer>
      {renderItem("Reporting enrollment id", enrollment.id)}
      {renderItem(
        "Submitted at",
        <Time d="(unset)" formatExact={"MMM DD, YYYY HH:mm:ss"}>
          {submitted}
        </Time>
      )}
      {enrollment.approvedAt ? renderItem("Approved at",
        <Time d="(unset)" formatExact={"MMM DD, YYYY HH:mm:ss"}>
          {enrollment.approvedAt}
        </Time>
      ) : null}
      {enrollment.status === "finished" && enrollment.finishedAt ? renderItem(
        "Finished at",
        <Time d="(unset)" formatExact={"MMM DD, YYYY HH:mm:ss"}>
          {enrollment.finishedAt}
        </Time>
      ) : null}
      {enrollment.status === "rejected" && enrollment.rejectedAt ? renderItem(
        "Rejected at",
        <Time d="(unset)" formatExact={"MMM DD, YYYY HH:mm:ss"}>
          {enrollment.rejectedAt}
        </Time>
      ) : null}

      <ListItem>
        <EnhancedStatusDisplay enrollment={enrollment} />
      </ListItem>
      {enrollment.consentType && renderItem("Consent Type", enrollment.consentType)}
      {enrollment.unenrolledByPartnerInfo && renderItem("Unenroll Info", enrollment.unenrolledByPartnerInfo)}
      <ListItem>
        <DetailSection title="Verifications">
          <ReportingAccountEnrollmentVerifications enrollmentId={enrollment?.id} />
        </DetailSection>
      </ListItem>
    </AlignedListContainer>
  );
};
